import FacilitatorNotifications from '@/src/components/game/FacilitatorNotifications/FacilitatorNotifications';
import React from 'react';

export const JamEventNotificationsPage: React.FC = () => {
  return <FacilitatorNotifications />;
};
